export default function slug(name) {
    return name
        .replaceAll(/[\/'"`’]/g, "")
        .replaceAll(/\s+/g, "-")
        .replaceAll(/-+/g, "-")
        .toLowerCase()
        .slice(0,32)
        .replaceAll(/^-+/g, "")
        .replaceAll(/-+$/g, "")
}